import {
  UPDATE_LIST,
  UPDATE_LIST_SUCCEEDED,
  UPDATE_LIST_FAILED,
} from "../types"

export const updateList = config => {
  return { type: UPDATE_LIST, config }
}

export const updateListSuccess = (action, response) => {
  return {
    type: UPDATE_LIST_SUCCEEDED,
    action,
    response,
    config: action.config,
  }
}

export const updateListError = (action, error) => {
  return { type: UPDATE_LIST_FAILED, action, error }
}
